class Controller {
  constructor($log) {
    "ngInject";
    $log.log("It's tickettypes Component");
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/tickettypes/tickettypes.controller.js